export * from "./LexiconConsts.ts"
export * from "./WordformTypes.ts"
export * from "./Wordform.ts"
export * from "./LemmaDef.ts"
